<template>
    <div class="address">
        <Address></Address>
    </div>
</template>

<script>
import Address from '../../components/address/Address.vue';

export default {
    name: 'addressC',
    components: {
        Address,
    },
};
</script>

<style lang="less" scoped>
</style>